export default class FAQSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.items = this.root.querySelectorAll('[data-faq-item]');

        this.answer = this.root.querySelectorAll('[data-faq-item-answer]');

        return true;
    }

    init() {
        this.initItems();

        this.onResize();
        window.addEventListener('resize', this.onResize.bind(this));
    }

    initItems() {
        if (!this.items) return;

        this.onItem = this.onItemClick.bind(this);
        this.items.forEach(item => {
            item.addEventListener('click', event => this.onItem(event));
        });
    }

    onItemClick(event) {
        const { currentTarget } = event;

        const answer = currentTarget.querySelector('.faq-section__answer');
        currentTarget.classList.toggle('active');

        console.log(answer);

        if (currentTarget.classList.contains('active')) {
            if (answer) {
                const height = parseInt(answer.getAttribute('max-height'));
                answer.style.maxHeight = `${height + 64}px`;
            }
        } else {
            if (answer) {
                answer.style.maxHeight = `0px`;
            }
        }
    }

    onResize() {
        if (!this.answer) return;

        this.answer.forEach(item => {
            const height = item.offsetHeight + 64;
            item.parentNode.setAttribute('max-height', height);
        });
    }
}
